import React from 'react'
import { toast } from 'react-toastify'
import { LoadingButton } from '@mui/lab'
import { Divider } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useMutation } from '@tanstack/react-query'
import NotificationAPI from 'api/faber/NotificationAPI'
import OrbitSession from 'hooks/useCookies'

export default function RefundReceiptDialog({
  refundReceiptDialogOpen,
  handleRefundReceiptDialogClose,
  transanctionNo,
  email
}: ReceiptDialog) {
  const faberToken = OrbitSession.get('faberToken')
  const {
    mutate: sendRefundReceipt,
    isLoading: isRefundReceiptSendingLoading
  } = useMutation(NotificationAPI.sendRefundReceipt, {
    onSettled: () => {
      handleRefundReceiptDialogClose()
    },
    onSuccess: () => {
      toast.success('Refund Receipt successfully sent')
    },
    onError: () => {
      toast.error('There is an error sending receipt to customer')
    }
  })

  const refundReceipt = () => {
    sendRefundReceipt({
      paymentId: transanctionNo,
      faberToken: faberToken
    })
  }

  return (
    <Dialog
      open={refundReceiptDialogOpen}
      onClose={handleRefundReceiptDialogClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title' sx={{ fontSize: '1.2em' }}>
        Send Refund Receipt
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          By taking this step, the customer will receive the refund receipt for
          the specific transaction: <b>{transanctionNo}</b>.<br /> The receipt
          will be sent to <b>{email}</b>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRefundReceiptDialogClose}>Cancel</Button>
        <LoadingButton
          variant='contained'
          onClick={refundReceipt}
          loading={isRefundReceiptSendingLoading}
          autoFocus
        >
          Send Receipt
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

interface ReceiptDialog {
  refundReceiptDialogOpen: boolean
  handleRefundReceiptDialogClose: () => void
  transanctionNo: string
  email: string
}
